export const IMG_LOGO_PATH = 'assets/images/logo/Qonnectiq-01.png';
export const IMG_LOGO_WHITE_PATH = 'assets/images/logo/Qonnectiq-Email.png';
export const IMG_SMALL_LOGO_PATH = 'assets/images/logo/Q-Logo-01.png';
export const IMAGE_NOT_AVAILABLE = 'assets/images/no-image.png';
export const LOGO_NOT_AVAILABLE = 'assets/images/no-logo.jpg';
